import React from 'react';
import PacienteForm from './PacienteForm';

const PacienteCreate = () => {
  return <PacienteForm />;
};

export default PacienteCreate;